import { ReactComponent as SvgSearch } from '@img/icons/search-apartments.svg';
import { ReactComponent as SvgSearchClose } from '@img/icons/search-icon-close.svg';
import { ReactComponent as SvgLogo } from '@img/misc/logo.svg';
import { Divide as Hamburger } from 'hamburger-react';
import * as React from 'react';
import NavigationDesktop from '../NavigationDesktop/NavigationDesktop';
import NavigationMobile from '../NavigationMobile/NavigationMobile';
import Search from '../Search/Search';
import S from './Header.styles';
import SearchButton from './SearchButton/SearchButton';
const Header = ({ sticky = true, theme = 'light', ...props }) => {
    const [isMobileNavActive, setIsMobileNavActive] = React.useState(false);
    const [isScrollActive, setIsScrollActive] = React.useState(false);
    const [activeItem, setActiveItem] = React.useState();
    const showOverlay = activeItem && activeItem.children !== null && activeItem.children.length > 0;
    const [isSearchActive, setIsSearchActive] = React.useState(false);
    const [isOpen, setIsOpen] = React.useState(false);
    React.useEffect(() => {
        if (isOpen) {
            setIsOpen(false);
        }
    }, [isOpen]);
    React.useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >= 1) {
                setIsScrollActive(true);
            }
            else {
                setIsScrollActive(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const toggleOverlay = () => {
        setIsMobileNavActive(false);
        setIsSearchActive(!isSearchActive);
    };
    const handleToggleMobileNav = () => {
        setIsMobileNavActive(!isMobileNavActive);
        setIsSearchActive(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(S.GlobalStyles, null),
        React.createElement(S.Wrapper, { "data-static": !sticky, "data-scroll-active": isScrollActive },
            React.createElement(S.Container, { id: "site_header", "data-theme": theme, "data-menu-active": showOverlay ?? isMobileNavActive },
                React.createElement(S.Main, null,
                    React.createElement(S.Inner, null,
                        React.createElement(S.MobileNav, { "aria-label": "Toggle Navigation", onClick: (event) => {
                                event.preventDefault();
                                handleToggleMobileNav();
                            } },
                            React.createElement("div", { style: { position: 'absolute', top: 0, left: -6, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                                React.createElement(Hamburger, { distance: "sm", color: "currentColor", size: 18, toggled: isMobileNavActive }))),
                        React.createElement(S.Logo, { href: "/", title: "Home" },
                            React.createElement(SvgLogo, null)),
                        React.createElement(NavigationDesktop, { activeItem: activeItem, currentPage: props.currentPage, items: props.items, setActiveItem: setActiveItem, showOverlay: showOverlay }),
                        props.quickLinks && (React.createElement(S.QuickLinks, null,
                            React.createElement(S.Inner, null,
                                props.quickLinks.map((link) => (React.createElement(S.QuickLink, { key: `header-quicklink-${link.id}`, href: link.url, target: link.target }, link.text))),
                                React.createElement(S.QuickLink, { key: `header-quicklink-${props.enquiriesCTA?.id}`, href: props.enquiriesCTA?.url, target: props.enquiriesCTA?.target }, props.enquiriesCTA?.text)))),
                        props.cta && (React.createElement(S.Cta, null,
                            React.createElement(SearchButton, { onClick: (e) => {
                                    e.preventDefault();
                                    toggleOverlay();
                                }, selected: isSearchActive, "data-fill": "right", icon: isSearchActive ? React.createElement(SvgSearchClose, null) : React.createElement(SvgSearch, null) }, props.cta.text))))),
                React.createElement(NavigationMobile, { active: isMobileNavActive, items: props.items, quickLinks: props.quickLinks, enquiriesCTA: props.enquiriesCTA, findAnApartmentCTA: props.findAnApartmentCTA }))),
        React.createElement(S.SearchMenu, { "data-show": isSearchActive },
            React.createElement(Search, { ...props.searchProps }))));
};
export default Header;
